import {useTranslation} from "react-i18next";

const url_pattern = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;

function WriteContent({register, required, errors}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="c-write write">
        <div className="c-write_header">
          <span className="c-header_number">2</span>
          <p className="c-header_title">{t('Rédiger le contenu')}</p>
        </div>
        <div className="c-write_content">
          <div className="c-content title">
            <p>{t('Saisissez le titre')}</p>
            <input type="text" name="title" {...register("title", { required : true})}/>
            {errors.title && <div className="c-errors">{t('Un titre est obligatoire')}</div>}

          </div>
          <div className="c-content text">
            <p>{t('Rédiger le contenu de l\'article')}</p>
            <textarea {...register("description", { required : true})}></textarea>
            {errors.description && <div className="c-errors">{t('Un contenu est obligatoire')}</div>}
          </div>
          <div className="c-content source">
            <div className="c-source_title">
              <p>{t('Source')}</p>
              <input type="text" name="name" {...register("source_name", { required : false})}/>
            </div>
            <div className="c-source_url">
              <p>{t('URL de la source')}</p>
              <input type="text" name="url" {...register("source_url", { required : false}, { pattern: url_pattern })}/>
              {errors.source_url && <div className="c-errors">{t('L\'url n\'est pas correcte')}</div>}
            </div>

            { /* disabled */
              false &&
              <div className="c-source_author">
                <p>{t('Auteur')}</p>
                <input type="text" name="author" {...register("source_author", { required : false})}/>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}


export default WriteContent
